import { combineReducers } from 'redux';
import { reducer as routerReducer } from 'redux-saga-first-router';
import { reducer as formReducer } from 'redux-form';
import auth, * as fromAuth from 'auth/reducer';
import sprintSubscriptions, * as fromSprintSubs from 'subscriptions/sprint/reducer';
import attSubscriptions, * as fromAttSubs from 'subscriptions/att/reducer';
import quickSubscriptions, * as fromQuickSubs from 'subscriptions/quick/reducer';
import purchases, * as fromPurchases from 'billing/purchases/reducer';
import paymentMethods, * as fromPaymentMethods from 'billing/paymentMethods/reducer';
import cycles, * as fromCycles from 'billing/cycles/reducer';
import quickCycles, * as fromQuickCycles from 'billing/cycles/quick/reducer';
import renewal, * as fromRenewal from 'billing/renewal/reducer';
import notifications, * as fromNotifications from 'notifications/reducer';
import sprintPlans, * as fromSprintPlans from 'subscriptions/plans/sprint/reducer';
import attPlans, * as fromAttPlans from 'subscriptions/plans/att/reducer';
import quickPlans, * as fromQuickPlans from 'subscriptions/plans/quick/reducer';
import usage, * as fromUsage from 'subscriptions/usage/sprint/reducer';
import attUsage, * as fromAttUsage from 'subscriptions/usage/att/reducer';
import quickUsage, * as fromQuickUsage from 'subscriptions/usage/quick/reducer';
import devices, * as fromDevices from 'devices/reducer';
import insurancePlans, * as fromInsurancePlans from 'insurance/insurancePlans/reducer';
import insuranceContracts, * as fromInsuranceContracts from 'insurance/insuranceContracts/reducer';
import insuredDevices, * as fromInsuredDevices from 'insurance/insuredDevices/reducer';
import products, * as fromProducts from 'ordersim/products/reducer';

export default combineReducers({
  routing: routerReducer,
  form: formReducer,
  auth,
  sprintSubscriptions,
  attSubscriptions,
  quickSubscriptions,
  usage,
  attUsage,
  quickUsage,
  purchases,
  paymentMethods,
  cycles,
  quickCycles,
  renewal,
  notifications,
  sprintPlans,
  attPlans,
  quickPlans,
  devices,
  insurancePlans,
  insuranceContracts,
  insuredDevices,
  products,
});

export const getUser = (state) => fromAuth.getUser(state.auth);
export const getResetEmail = (state) => fromAuth.getResetEmail(state.auth);
export const getAutopayEnabled = (state) => fromAuth.getAutopayEnabled(state.auth);
export const getAuthRedirect = (state) => fromAuth.getAuthRedirect(state.auth);
export const getShowVerificationCode = (state) => fromAuth.getShowVerificationCode(state.auth);
export const getLoginTimerTime = (state) => fromAuth.getLoginTimerTime(state.auth);
export const getForceShowVerification = (state) => fromAuth.getForceShowVerification(state.auth);
export const getMdnValid = (state) => fromAuth.getMdnValid(state.auth);


export const getCurrentPurchase = (state) => fromPurchases.getCurrentPurchase(state.purchases);
export const getPurchase = (state, id) => fromPurchases.getPurchase(state.purchases, id);
export const getFilteredPurchase = (state, id) => fromPurchases.getFilteredPurchase(state.purchases, id);
export const getPurchaseHistory = (state, page) => fromPurchases.getPurchaseHistory(state.purchases, page);
export const getHistoryPagination = (state, page) => fromPurchases.getHistoryPagination(state.purchases, page);
export const getOverduePurchases = (state) => fromPurchases.getOverduePurchases(state.purchases);

export const getGroupedLineItems = (state, id) => fromPurchases.getGroupedLineItems(state.purchases, id);
export const getDefaultPaymentMethod = (state) => fromPaymentMethods.getDefaultPaymentMethod(state.paymentMethods);
export const getAllPaymentMethods = (state) => fromPaymentMethods.getAllPaymentMethods(state.paymentMethods);
export const getDeletePaymentMethodStatus = (state, id) => fromPaymentMethods.getDeletePaymentMethodStatus(state.paymentMethods, id);

export const getSprintSubscription = (state, id) => fromSprintSubs.getSprintSubscription(state.sprintSubscriptions, id)
export const getAllSprintSubscriptions = (state) => fromSprintSubs.getAll(state.sprintSubscriptions);
export const getCurrentSprintPlan = (state, id) => fromSprintSubs.getCurrentPlan(state.sprintSubscriptions, id);
export const getUpcomingSprintPlan = (state, id) => fromSprintSubs.getUpcomingPlan(state.sprintSubscriptions, id);
export const getSprintUpgradePurchase = (state, id) => fromSprintSubs.getUpgradePurchase(state.sprintSubscriptions, id);
export const getSprintInsuranceContractId = (state, id) => fromSprintSubs.getInsuranceContractId(state.sprintSubscriptions, id);

export const getAttSubscription = (state, id) => fromAttSubs.getAttSubscription(state.attSubscriptions, id)
export const getAllAttSubscriptions = (state) => fromAttSubs.getAll(state.attSubscriptions);
export const getCurrentAttPlan = (state, id) => fromAttSubs.getCurrentPlan(state.attSubscriptions, id);
export const getUpcomingAttPlan = (state, id) => fromAttSubs.getUpcomingPlan(state.attSubscriptions, id);
export const getAttUpgradePurchase = (state, id) => fromAttSubs.getUpgradePurchase(state.attSubscriptions, id);
export const getAttInsuranceContractId = (state, id) => fromAttSubs.getInsuranceContractId(state.attSubscriptions, id);

export const getQuickSubscription = (state, id) => fromQuickSubs.getQuickSubscription(state.quickSubscriptions, id)
export const getAllQuickSubscriptions = (state) => fromQuickSubs.getAll(state.quickSubscriptions);
export const getCurrentQuickPlan = (state, id) => fromQuickSubs.getCurrentPlan(state.quickSubscriptions, id);
export const getUpcomingQuickPlan = (state, id) => fromQuickSubs.getUpcomingPlan(state.quickSubscriptions, id);
export const getQuickUpgradePurchase = (state, id) => fromQuickSubs.getUpgradePurchase(state.quickSubscriptions, id);
export const getQuickInsuranceContractId = (state, id) => fromQuickSubs.getInsuranceContractId(state.quickSubscriptions, id);

export const getCurrentUsage = (state, subId) => fromUsage.getCurrentUsage(state.usage, subId);
export const getCurrentAttUsage = (state, subId) => fromAttUsage.getCurrentUsage(state.attUsage, subId);
export const getCurrentQuickUsage = (state, subId, format=true) => fromQuickUsage.getCurrentUsage(state.quickUsage, subId, format);

export const getInfo = (state, key) => fromNotifications.getInfo(state.notifications, key);
export const getError = (state, key) => fromNotifications.getError(state.notifications, key);

export const getUpcomingCycle = (state) => fromCycles.getUpcomingCycle(state.cycles);
export const getCurrentCycle = (state) => fromCycles.getCurrentCycle(state.cycles);

export const getCurrentQuickCycle = (state, subId) => fromQuickCycles.getCurrentCycle(state.quickCycles, subId);

export const getRenewalUnpaid = (state) => fromRenewal.getRenewalUnpaid(state.renewal);
export const getRenewalTotal = (state) => fromRenewal.getRenewalTotal(state.renewal);
export const getRenewalPurchase = (state) => fromRenewal.getRenewalPurchase(state.renewal);

export const getAllSprintPlans = (state) => fromSprintPlans.getAllPlans(state.sprintPlans);
export const getSprintPlan = (state, id) => fromSprintPlans.getPlan(state.sprintPlans, id);

export const getAllAttPlans = (state) => fromAttPlans.getAllPlans(state.attPlans);
export const getAttPlan = (state, id) => fromAttPlans.getPlan(state.attPlans, id);

export const getAllQuickPlans = (state) => fromQuickPlans.getAllPlans(state.quickPlans);
export const getQuickPlan = (state, id) => fromQuickPlans.getPlan(state.quickPlans, id);

export const getDevice = (state, id) => fromDevices.get(state.devices, id);
export const getFilteredDevices = (state) => fromDevices.getFiltered(state.devices);

export const getInsurancePlan = (state, id) => fromInsurancePlans.get(state.insurancePlans, id);
export const getInsurancePlans = (state) => fromInsurancePlans.getPlans(state.insurancePlans);
export const getInsurancePlansForValue = (state, value) => fromInsurancePlans.getValue(state.insurancePlans, value);

export const getFilteredInsuranceContracts = (state, params) => fromInsuranceContracts.getFiltered(state.insuranceContracts, params);
export const getInsuranceContractFetchStatus = (state) => fromInsuranceContracts.getFilteredRequestStatus(state.insuranceContracts);
export const getInsuranceContract = (state, id) => fromInsuranceContracts.get(state.insuranceContracts, id);
export const getInsuredDeviceId = (state, id) => fromInsuranceContracts.getInsuredDeviceId(state.insuranceContracts, id);

export const getFilteredInsuredDevices = (state, contractId) => fromInsuredDevices.getFiltered(state.insuredDevices, contractId);
export const getInsuredDevice = (state, id) => fromInsuredDevices.get(state.insuredDevices, id);
export const getInsuredDeviceFetchStatus = (state) => fromInsuredDevices.getFilteredRequestStatus(state.insuredDevices);

export const getProduct = (state, id) => fromProducts.getProduct(state.products, id);
export const getInsuredDevicePurchase = (state, id) => fromInsuredDevices.getPurchase(state.insuredDevices, id);

/* get error messages */
export const getInsuranceContractCreateError = (state) => fromInsuranceContracts.getCreateError(state.insuranceContracts);
export const getInsuredDeviceCreateError = (state) => fromInsuredDevices.getCreateError(state.insuredDevices);
export const getInsuredDeviceActivationError = (state) => fromInsuredDevices.getActivationError(state.insuredDevices);
export const getGetAllPurchasesError = (state) => fromPurchases.getGetAllError(state.purchases);
